import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Printer } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { ddmmyyyy } from "@/lib/format";
import { PersonLedgerView } from "@/components/PersonLedgerView";

export default function PublicPersonPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/public/person/${token}`).then((r) => setData(r.data)).catch((e) => setErr(errMsg(e)));
  }, [token]);

  if (err) return <p className="p-10 text-sm text-red-700" data-testid="person-share-error">{err}</p>;
  if (!data) return <p className="p-10 text-sm text-slate-500" data-testid="person-share-loading">Loading ledger…</p>;

  return (
    <div className="min-h-screen grid-paper print:bg-white">
      <div className="no-print bg-slate-900 text-white">
        <div className="max-w-5xl mx-auto px-4 h-12 flex items-center gap-3 text-xs">
          <span className="text-white/70" data-testid="person-share-expiry">Shared ledger · valid until {ddmmyyyy(data.expires_at.slice(0, 10))}</span>
          <button data-testid="person-share-print-btn" onClick={() => window.print()}
            className="ml-auto h-8 px-3 bg-yellow-300 text-slate-900 font-bold flex items-center gap-1.5 hover:bg-yellow-200">
            <Printer size={14} /> Print
          </button>
        </div>
      </div>
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-8 space-y-5">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500 mb-2">Cashout ledger · all months</p>
          <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight" data-testid="person-ledger-name">{data.name}</h1>
          <p className="text-xs text-slate-500 mt-2">As of {ddmmyyyy(new Date().toISOString().slice(0, 10))}</p>
        </div>
        <PersonLedgerView data={data} />
      </main>
    </div>
  );
}
